import React from 'react'

const Apicontext = React.createContext()

export default Apicontext;